import React, { useState } from "react";
import logo from "../assets/img/IHU-Logo.png"; 

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const callNumber = () => {
    window.location.href = "tel:+917439213152";
  };

  return (
    <header>
      <nav className="container">
        <a className="logo" href="#">
          <img src={logo} alt="IHU Logo" width={120} height={50} />
        </a>
        <button className="btn-null" id="collapse-btn" onClick={toggleMenu}>
          <i className="fa-solid fa-bars"></i>
        </button>
        <div className={`collapse ${isMenuOpen ? "collapse-open" : ""}`} id="nav-menu">
          <ul>
            {["Home", "About Us", "Services", "Testimonial", "Contact"].map((item, index) => (
              <li key={index}>
                <a className="nav-link" href={`#${item.toLowerCase().replace(" ", "")}`}>
                  {item}
                </a>
              </li>
            ))}
          </ul>
          <button onClick={callNumber} className="call-res btn-null btn-primary">
            <i className="fa-solid fa-phone-volume"></i> Call Us
          </button>
        </div>
        <button onClick={callNumber} className="call-btn btn-null btn-primary">
          <i className="fa-solid fa-phone-volume"></i> Call Us
        </button>
      </nav>
    </header>
  );
}

export default Header;
